import { render, staticRenderFns } from "./ActionMealLogMeal.vue?vue&type=template&id=d4639152&scoped=true"
import script from "./ActionMealLogMeal.vue?vue&type=script&lang=js"
export * from "./ActionMealLogMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4639152",
  null
  
)

export default component.exports